import { UserDetailsWidget } from '@/bundle/shared/components/UserDetailsWidget/UserDetailsWidget';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { showSnackbarResponseError } from '@/helpers/helpers';
import { isDepositorInvitedWireStatus } from '@/helpers/wireHelpers';
import { AssignedWireType } from '@/types/wireTypes';
import { DetailsEditButton } from '@/bundle/_OrgAdmin/shared/ui/DetailsEditButton/DetailsEditButton';
import { ReInvitationDetails } from '@/bundle/shared/components/UserDetailsWidget/ReInvitationDetails';
import { useParams } from 'react-router';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { reinviteDepositor } from '@/bundle/_OrgAdmin/pages/InboundWire/api/api';

type DepositorUserDetailsType = {
  inboundWire: AssignedWireType;
  onRefetchWire: () => void;
  onEdit: () => void;
};

export const DepositorUserDetails = ({ inboundWire, onRefetchWire, onEdit }: DepositorUserDetailsType) => {
  const { id } = useParams<{ transactionId: string; id: string }>();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const { mutate: reinviteDepositorMutate } = useMutation({
    mutationKey: ['reinvite_depositor'],
    mutationFn: () => {
      return reinviteDepositor(id);
    },
    onSuccess(response) {
      if (response?.error) {
        onRefetchWire();
        setIsOpenModal(false);

        return showSnackbarResponseError(response?.error);
      }

      onRefetchWire();
      setIsOpenModal(false);
    },
  });

  const openEditDepositorInfo = () => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.EditDepositorInfoRedirect);

    onEdit();
  };

  const wireStatus = inboundWire?.status;
  const assignedDepositor = inboundWire?.assigned_depositor?.user;
  const isDepositorInvited = isDepositorInvitedWireStatus(wireStatus);

  return (
    <UserDetailsWidget
      header='Depositor'
      user={assignedDepositor}
      action={isDepositorInvited && <DetailsEditButton onEdit={openEditDepositorInfo} />}
      hasInvitedNotification={isDepositorInvited}
    >
      {isDepositorInvited && (
        <ReInvitationDetails
          onConfirm={reinviteDepositorMutate}
          invitationDetails={assignedDepositor?.invitation_data}
          onOpen={() => setIsOpenModal(true)}
          onClose={() => setIsOpenModal(false)}
          isOpen={isOpenModal}
          onRefetchWire={onRefetchWire}
        />
      )}
    </UserDetailsWidget>
  );
};
